<template>
  <div>
    <PlatformsTemplate :platforms="platforms" @go-to-platform="goToPlatform"></PlatformsTemplate>
  </div>
</template>

<script>
  import PlatformsTemplate from '@/components/templates/PlatformsTemplate';
  import { mapState } from 'vuex';

  export default {
    components: { PlatformsTemplate },
    created() {
      this.$store.dispatch('fetchPlatforms');
    },
    computed: mapState({
      platforms: state => state.platforms,
    }),
    methods: {
      goToPlatform(platform) {
        this.$router.push({ name: 'platform', params: { platform } });
      },
    },
  };
</script>
